export const getResearchReportTabsUrl =  `/portal-news/report/item`;

export const getListReseachReportUrl = `/portal-news/report/title`;   

export const getDetailReseachReportUrl = (nodeId: string) =>
    `/portal-news/report/${nodeId}/data`;